import { Action, ActionReducer, combineReducers } from '@ngrx/store';

import * as fromSiteGateways from './site-gateways.reducer';
import * as fromSiteProducts from './site-products.reducer';
import * as fromSiteWards from './site-wards.reducer';
import * as fromSite from './site.reducer';

export const featureKey = 'oyanSites';

export interface SitesState {
  [fromSite.featureKey]: fromSite.State;
  [fromSiteGateways.featureKey]: fromSiteGateways.State;
  [fromSiteProducts.featureKey]: fromSiteProducts.State;
  [fromSiteWards.featureKey]: fromSiteWards.State;
}

export interface State {
  [featureKey]: SitesState;
}

export function reducers(state: SitesState, action: Action): ActionReducer<SitesState> {
  return combineReducers({
    [fromSite.featureKey]: fromSite.reducer,
    [fromSiteGateways.featureKey]: fromSiteGateways.reducer,
    [fromSiteProducts.featureKey]: fromSiteProducts.reducer,
    [fromSiteWards.featureKey]: fromSiteWards.reducer
  })(state, action) as unknown as ActionReducer<SitesState>;
}
